export enum TemplatesPermissions {
  GET_COLLECTION_MANAGEMENT_VIEW = 'templates.getCollectionManagementView',
  GET_TEMPLATES = 'templates.getTemplates',
  PERSIST_TEMPLATE = 'templates.persistTemplate',
  DELETE_TEMPLATE = 'templates.deleteTemplate',
  USE_PROPOSAL_TEMPLATES = 'templates.useProposalTemplates',
}
